import React from 'react'
import moment from 'moment-timezone'
import PropTypes from 'prop-types'
import { Spinner } from 'transfix-ui/components/Spinner'
import { FORMATS } from 'constants/datetime'

export const ReservedOfferDetails = ({ details, error, loading, shipment }) => {
  if (error) {
    return <p>Reserved for details are not available</p>
  }
  if (loading) {
    return <Spinner />
  }
  if (!details) {
    return null
  }

  const { currentMatch, nextKickoff, totalMatches } = details
  let kickoffDetails = null

  if (nextKickoff) {
    const nextKickoffUtc = moment.utc(nextKickoff, FORMATS.iso8601Format)
    const kickoffDate = nextKickoffUtc.isSame(moment.utc(), 'day')
      ? 'Today'
      : nextKickoffUtc.format(FORMATS.dayShort)
    const kickoffTime = nextKickoffUtc
      .tz(FORMATS.defaultTimeZone)
      .format(FORMATS.militaryTimeFormat)
    kickoffDetails = (
      <p>
        Next offer will be sent {kickoffDate} at {kickoffTime}
      </p>
    )
  }

  if (shipment && shipment.info && shipment.info.carrierId) {
    return (
      <p data-test='reserved-offer-details'>
        <span className='text-default'>
          Reserved for carrier {currentMatch} of {totalMatches}.
        </span>
      </p>
    )
  }

  return (
    <>
      <p data-test='reserved-offer-details'>This shipment is reserved.</p>
      {kickoffDetails}
    </>
  )
}

ReservedOfferDetails.propTypes = {
  details: PropTypes.shape({
    currentMatch: PropTypes.number,
    totalMatches: PropTypes.number,
    datMarketLaneId: PropTypes.string,
    nextKickoff: PropTypes.string,
  }),
  loading: PropTypes.bool,
  error: PropTypes.string,
  shipment: PropTypes.shape({
    info: PropTypes.shape({
      carrierId: PropTypes.number,
    }),
  }),
}

ReservedOfferDetails.defaultProps = {
  details: null,
  loading: false,
  error: null,
  shipment: null,
}
